// extracted by mini-css-extract-plugin
export default {"sizes":"kVskL","column":"piROt","size":"bV5qp","last":"_XjK7","sizeX":"GVybO","title":"Cpqj7","value":"BNrcw"};